// removed by extract-text-webpack-plugin
module.exports = {"row":"_2iWyp33cUdyFQQLcBag9Bj","col":"_1nL-bA_t5TwrAWFr8LljFQ","col-md-1":"k3QHHkGrPM0hTraKU3jRO","col-md-4":"N8NFe5yzsz_cedmIB6tZh","col-md-6":"_1GYwfAoDT32w2wxMCksJry","col-md-12":"TKelnKB-G2cvycO7X1--T","pull-right":"_3Yjprj65bcHJoypBK4k95G","pull-left":"_3KkrLZLkbXUhRcN0g3T7cW","padding8":"_2LncIkn4IuKo3kApP38rX8","padding16":"tvPE19o5eBH16h9aSR_vU","button-label":"_3aekkF71wX_f3LAnSIbpra","button-padded":"_1sI6GOpZiLu3Oo3EsnKR_J","Software__Title":"_3UOVq_QNo-8v4Zoy78SBzj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserDownload/UserDownload.scss
// module id = 1238
// module chunks = 0